import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Repo = _resolveComponent("Repo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Object(_ctx.repositories).sort((a, b) =>
        a.name.localeCompare(b.name)
      ), (repo, index) => {
      return (_openBlock(), _createBlock(_component_Repo, {
        key: index,
        repo: repo,
        langs: _ctx.langs
      }, null, 8, ["repo", "langs"]))
    }), 128))
  ]))
}